import Entity from '../entity'

export default class ManufacturerModel extends Entity<number>{
    manufacturer_id: number;
    name: string;
}


